import React from 'react';
import PropTypes from 'prop-types';
import EmailMessageListItem from "./EmailMessageListItem";
import EmailMessageReply from "./EmailMessageReply";
import { fromJS } from 'immutable';
import _ from 'lodash';
import './EmailMessageList.css';


export default class EmailMessageList extends React.Component {

    static propTypes = {
        accountEmail: PropTypes.string.isRequired,
        thread: PropTypes.object.isRequired,
        refetchThread: PropTypes.func.isRequired,
        uploadFile: PropTypes.func.isRequired,
        replyToMessage: PropTypes.func.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);

        this.state = Object.assign({
            errorMessage: null,
            fetching: false,
            olderMessagesExpanded: false,
            expandedMapByMessageId: null
        });

        Object.assign(this.state, this.stateFromProps(props));

        this.replyToMessage = this.replyToMessage.bind(this);
        this.onOlderMessagesClick = this.onOlderMessagesClick.bind(this);
        this.onExpandMessage = this.onExpandMessage.bind(this);
        this.onCollapseMessage = this.onCollapseMessage.bind(this);
        this.onCollapseAllClick = this.onCollapseAllClick.bind(this);
        this.onExpandAllClick = this.onExpandAllClick.bind(this);
        this._onFail = this._onFail.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState(this.stateFromProps(nextProps));
    }

    stateFromProps(props) {
        if (this.state.expandedMapByMessageId === null) {
            let expandedMapByMessageId = _.transform(props.thread.messages, (map, message, index) => {
                map[message.id] = (index === props.thread.messages.length - 1);
            }, {});

            return {
                fetching: false,
                expandedMapByMessageId: fromJS(expandedMapByMessageId)
            };
        }
        return {};
    }

    replyToMessage(messageId, from, to, body, files) {
        return this.props.replyToMessage(messageId, from, to, body, files).then(() => {
            // After successful reply, reset state and fetch everything again.
            this.setState({
                errorMessage: null,
                fetching: true,
                olderMessagesExpanded: false,
                expandedMapByMessageId: null
            }, () => {
                this.props.refetchThread(this.props.thread.id).catch(this._onFail);
            });
        });
    }

    _onFail(error) {
        this.setState({
            errorMessage: error.message,
            fetching: false
        });
        return Promise.reject(error);
    }

    onOlderMessagesClick() {
        this.setState({olderMessagesExpanded: true});
    }

    onExpandMessage(messageId) {
        this.toggleMessageExpandedState(messageId);
    }

    onCollapseMessage(messageId) {
        this.toggleMessageExpandedState(messageId);
    }

    toggleMessageExpandedState(messageId) {
        this.setState((prevState) => {
            let prevValue = prevState.expandedMapByMessageId.get(messageId);
            return {
                expandedMapByMessageId: prevState.expandedMapByMessageId.set(messageId, !prevValue)
            };
        });
    }

    onCollapseAllClick() {
        let lastMessageId = _.last(this.props.thread.messages).id;
        let expandedMapByMessageId = this.state.expandedMapByMessageId.withMutations(map => {
            map.forEach((expanded, messageId) => {
                map.set(messageId, messageId === lastMessageId);
            });
        });
        this.setState({expandedMapByMessageId});
    }

    onExpandAllClick() {
        let expandedMapByMessageId = this.state.expandedMapByMessageId.withMutations(map => {
            map.forEach((expanded, messageId) => {
                map.set(messageId, true);
            });
        });
        this.setState({
            olderMessagesExpanded: true,
            expandedMapByMessageId: expandedMapByMessageId
        });
    }

    renderMessageList() {
        let messages = this.props.thread.messages;
        if (!this.state.olderMessagesExpanded && this.props.thread.messages.length > 5) {
            messages = [_.head(messages), null, _.nth(messages, -2), _.nth(messages, -1)];
        }
        let listItems = messages.map((message, index) => {
            if (message === null) {
                return this.renderOlderMessageListItem(index);
            }
            let collapsible = index !== messages.length - 1;
            let expanded = this.state.expandedMapByMessageId.get(message.id);
            return (
                <li key={index} className="emailMessageListItem">
                    <EmailMessageListItem
                        expanded={expanded}
                        collapsible={collapsible}
                        message={message}
                        onExpand={this.onExpandMessage}
                        onCollapse={this.onCollapseMessage}
                    />
                </li>
            );
        });
        return <ul className="emailMessageList">{listItems}</ul>
    }

    renderOlderMessageListItem(index) {
        return (
            <li key={index} className="emailMessageListItem">
                <div className="olderMessages" onClick={this.onOlderMessagesClick}>
                    <div className="olderMessagesLine olderMessagesTopLine"/>
                    <div className="olderMessagesLine olderMessagesBottomLine"/>
                    <div className="olderMessagesText">{this.props.thread.messages.length - 3} older messages</div>
                </div>
            </li>
        );
    }

    renderExpandAllButton() {
        if (_.every(this.state.expandedMapByMessageId.toJS())) {
            return <div className="expandAllButton" onClick={this.onCollapseAllClick}><i className="fa fa-lg fa-minus-square-o"/></div>;
        } else {
            return <div className="expandAllButton" onClick={this.onExpandAllClick}><i className="fa fa-lg fa-plus-square-o"/></div>;
        }
    }

    render() {
        if (this.state.fetching) {
            return (<div>Loading...</div>);
        }
        if (!this.props.thread.messages.length) {
            return <div>No emails</div>;
        }
        return (
            <div className="emailPlugin">
                <div className="threadToolbar">
                    <div className="threadSubject ellipsisTruncate">{this.props.thread.subject}</div>
                    {this.renderExpandAllButton()}
                </div>
                {this.renderMessageList()}
                <EmailMessageReply
                    accountEmail={this.props.accountEmail}
                    thread={this.props.thread}
                    uploadFile={this.props.uploadFile}
                    replyToMessage={this.replyToMessage}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/plugins/emailPlugin/EmailMessageList.js